import { ROUTE_IDS } from "./routeIds";
import { normalizeLocale } from "./routeLocale";

/**
 * Post-login destination by user type + route locale.
 * Hebrew → dashboard home; all other locales → hotel search only (Sprint 2).
 */
export function resolvePostLoginRouteId(userType, locale) {
  const ut = String(userType || "").toLowerCase();
  const lng = normalizeLocale(locale);

  if (ut === "clients" || ut === "client") {
    return ROUTE_IDS.SECURE_CLIENT_ROOT;
  }
  if (ut === "administrators" || ut === "admin") {
    return ROUTE_IDS.ADMINISTRATION;
  }
  if (lng === "he") {
    return ROUTE_IDS.DASHBOARD_HOME;
  }
  return ROUTE_IDS.HOTEL_SEARCH;
}
